import meStore from "./meStore";
import appStore from "./appStore";
import userStore from "./userStore";
import companyStore from "./companyStore";
import courierStore from "./courierStore";
import orderStore from "./orderStore";
import apiRequestStore from "./apiRequestStore";
import appConfigStore from "./appConfigStore";
import statisticStore from "./statisticStore";
import heatMapStore from "./heatMapStore";
import walletStore from "./walletStore";
import courierAdjustmentStore from "./courierAdjustmentStore";
import ticketTypeStore from "./ticketTypeStore";
import ticketStore from "./ticketStore";
import applicationStore from "./applicationStore";
import shiftStore from "./shiftStore";
import transferStore from "./transferStore";
import shiftSuggestionStore from "./shiftSuggestionStore";
import paymentPeriodStore from "./paymentPeriodStore";
import authorizationStore from "./authorizationStore";
import poolStore from "./poolStore";
import reportTemplateStore from "./reportTemplateStore";
import locationStore from "./locationStore";
import shiftRequestStore from "./shiftRequestStore";
import poolShiftStore from "./poolShiftStore";
import courierBonusCampaignStore from "./courierBonusCampaignStore";
import optionsStore from "./optionsStore";
import codPaymentStore from "./codPaymentStore";
import contractStore from "./contractStore";
import supplierStore from "./supplierStore";
import integratorStore from "./integratorStore";
import subCompanyStore from "./subCompanyStore";
import operationOrganizationStore from "./operationOrganizationStore";
import optionStore from "./optionStore";
import callStore from "./callStore";
import subcompanyUserStore from "./subcompanyUserStore";
import courierRequestStore from "./courierRequestStore";
import equipmentStore from "./equipmentStore";
import equipmentRequestStore from "./equipmentRequestStore";
import fileStore from "./fileStore";
import courierWithdrawRequestStore from "./courierWithdrawRequestStore";
import metabaseReportStore from "./metabaseReportStore";

export default {
    meStore,
    appStore,
    authorizationStore,
    userStore,
    companyStore,
    courierStore,
    orderStore,
    apiRequestStore,
    appConfigStore,
    statisticStore,
    walletStore,
    courierAdjustmentStore,
    ticketTypeStore,
    ticketStore,
    applicationStore,
    heatMapStore,
    shiftStore,
    transferStore,
    reportTemplateStore,
    shiftSuggestionStore,
    paymentPeriodStore,
    poolStore,
    poolShiftStore,
    courierBonusCampaignStore,
    locationStore,
    shiftRequestStore,
    optionsStore,
    codPaymentStore,
    contractStore,
    supplierStore,
    integratorStore,
    subCompanyStore,
    operationOrganizationStore,
    optionStore,
    callStore,
    subcompanyUserStore,
    courierRequestStore,
    equipmentStore,
    equipmentRequestStore,
    fileStore,
    courierWithdrawRequestStore,
    metabaseReportStore
};
